const config = {
  baseUrl: "https://digitalkioskapi.appinsnap.com/api",
};

export default config;
